import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";

export const getDashboardApi = async (payload) => {
    return await api.get(
        `${apiPath.API_URL}${apiPath.Attendance.dashboard}`,
        {params: payload,}
    );
}

export const getAttendanceListApi = async (payload) => {
    return await api.get(
        `${apiPath.API_URL}${apiPath.Attendance.dashboardList}`,
        {
            params: payload,
        }
    );
}
export const generateAttendanceApi = async (payload) => {
    return await api.post(
        `${apiPath.API_URL}${apiPath.Attendance.generateAttendance}`,{},{
            params: payload,
        }
    );
};